export default function productFunctions() {
  // set offset (in case of sticky header) for sticky
  const has_sticky_header = document.querySelector(
    "[data-function='sticky-header']"
  );
  if (has_sticky_header) {
    const sticky_header_height = has_sticky_header.offsetHeight + 30;
    const $infos = document.querySelector(
      ".product-template__col-info-wrapper"
    ) as HTMLElement;
    if ($infos) {
      $infos.style.top = `${sticky_header_height}px`;
    }
  }

  // Responsive product images slider

  const product_template_slider = new Swiper(
    ".product-template__slider .swiper-container",
    {
      speed: 800,
      lazy: true,
      autoplay: false,
      slidesPerView: 1,
      pagination: {
        el: ".product-template__slider .swiper-pagination",
        clickable: true,
      },
    }
  );

  // Product main v2 slider thumbnails

  const product_main_v2_thumbs = new Swiper(
    ".product-main-v2__slider .thumbs-slider",
    {
      spaceBetween: 10,
      slidesPerView: 5,
      freeMode: true,
      watchSlidesProgress: true,

    }
  );

  // Product main v2 slider

  const product_main_v2_slider = new Swiper(
    ".product-main-v2__slider .main-slider",
    {
      speed: 800,
      lazy: true,
      autoplay: false,
      slidesPerView: 1,
      thumbs: {
        swiper: product_main_v2_thumbs,
      },
    }
  );

  // Desktop product viewer

  const product_viewer = new Swiper(".product-viewer .swiper-container", {
    autoplay: false,
    slidesPerView: 1,
    speed: 800,
    navigation: {
      nextEl: ".product-viewer .swiper-button-next",
      prevEl: ".product-viewer .swiper-button-prev",
    },
  });

  // Variant images slider thumbnails

  const activeSlideThumb = document.querySelector(
    ".variant-images-slider__thumbnails .swiper-slide[active]"
  ) as HTMLElement;
  let indexThumb = 0;
  if (activeSlideThumb && activeSlideThumb.dataset.index) {
    indexThumb = Number(activeSlideThumb.dataset.index);
  }

  const variant_images_slider_thumbs = new Swiper(
    ".variant-images-slider__thumbnails",
    {
      speed: 800,
      lazy: true,
      autoplay: false,
      slidesPerView: "auto",
      initialSlide: indexThumb,
      freeMode: true,
      watchSlidesProgress: true,
    }
  );

  // Variant images slider

  const activeSlide = document.querySelector(
    ".variant-images-slider .swiper-slide[active]"
  ) as HTMLElement;
  let index = 0;
  if (activeSlide && activeSlide.dataset.index) {
    index = Number(activeSlide.dataset.index);
  }

  new Swiper(".variant-images-slider", {
    speed: 800,
    lazy: true,
    autoplay: false,
    slidesPerView: 1,
    initialSlide: index,
    thumbs: {
      swiper: variant_images_slider_thumbs,
    },
  });

  // Slide to product image

  function slideTo(index) {
    let index_num = Number(index);
    product_viewer.slideTo(index_num);
  }
}
